import React, { PropsWithChildren, useMemo, useState } from 'react'

export interface HeaderContextProps {
  portalRef?: React.MutableRefObject<HTMLDivElement | null>
  setPortalRef: (ref: React.RefObject<HTMLDivElement>) => void
}
export const HeaderContext = React.createContext<HeaderContextProps>({ setPortalRef: () => {} })

export const HeaderContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [portalRef, setPortalRef] = useState<React.RefObject<HTMLDivElement>>()

  const contextProps = useMemo(() => {
    return {
      portalRef,
      setPortalRef,
    }
  }, [portalRef, setPortalRef])

  return <HeaderContext.Provider value={contextProps}>{children}</HeaderContext.Provider>
}
